import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { MovuRobotics_DatasourceService } from './MovuRobotics.datasource.index';

import { app_custom_ds_get_license_plate_details_by_licensePlateIdService } from './app.datasource.index';
import { app_custom_ds_get_license_plate_details_by_licensePlateId_v2Service } from './app.datasource.index';
import { app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService } from './app.datasource.index';
import { app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService } from './app.datasource.index';
import { app_custom_ds_get_load_container_by_pick_taskIdService } from './app.datasource.index';
import { app_custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentIdService } from './app.datasource.index';
import { app_custom_ds_get_pallet_induction_info_by_licensePlateIdService } from './app.datasource.index';
import { app_custom_ds_get_pick_task_by_taskidService } from './app.datasource.index';
import { app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService } from './app.datasource.index';
import { app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service } from './app.datasource.index';
import { app_ds_get_pick_tasks_by_licensePlateIdService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.MovuRobotics = this.injector.get(MovuRobotics_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public MovuRobotics: MovuRobotics_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_get_license_plate_details_by_licensePlateId: app_custom_ds_get_license_plate_details_by_licensePlateIdService;
  public get custom_ds_get_license_plate_details_by_licensePlateId(): app_custom_ds_get_license_plate_details_by_licensePlateIdService {
    if(!this._custom_ds_get_license_plate_details_by_licensePlateId) {
      this._custom_ds_get_license_plate_details_by_licensePlateId = this.injector.get(app_custom_ds_get_license_plate_details_by_licensePlateIdService);
    }
    return this._custom_ds_get_license_plate_details_by_licensePlateId;
  }
  private _custom_ds_get_license_plate_details_by_licensePlateId_v2: app_custom_ds_get_license_plate_details_by_licensePlateId_v2Service;
  public get custom_ds_get_license_plate_details_by_licensePlateId_v2(): app_custom_ds_get_license_plate_details_by_licensePlateId_v2Service {
    if(!this._custom_ds_get_license_plate_details_by_licensePlateId_v2) {
      this._custom_ds_get_license_plate_details_by_licensePlateId_v2 = this.injector.get(app_custom_ds_get_license_plate_details_by_licensePlateId_v2Service);
    }
    return this._custom_ds_get_license_plate_details_by_licensePlateId_v2;
  }
  private _custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId: app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService;
  public get custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId(): app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService {
    if(!this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId) {
      this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId = this.injector.get(app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService);
    }
    return this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateId;
  }
  private _custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotId: app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService;
  public get custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotId(): app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService {
    if(!this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotId) {
      this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotId = this.injector.get(app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotIdService);
    }
    return this._custom_ds_get_license_plate_info_for_alter_pallet_hold_by_lotId;
  }
  private _custom_ds_get_load_container_by_pick_taskId: app_custom_ds_get_load_container_by_pick_taskIdService;
  public get custom_ds_get_load_container_by_pick_taskId(): app_custom_ds_get_load_container_by_pick_taskIdService {
    if(!this._custom_ds_get_load_container_by_pick_taskId) {
      this._custom_ds_get_load_container_by_pick_taskId = this.injector.get(app_custom_ds_get_load_container_by_pick_taskIdService);
    }
    return this._custom_ds_get_load_container_by_pick_taskId;
  }
  private _custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentId: app_custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentIdService;
  public get custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentId(): app_custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentIdService {
    if(!this._custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentId) {
      this._custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentId = this.injector.get(app_custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentIdService);
    }
    return this._custom_ds_get_load_container_for_shipment_download_on_success_by_shipmentId;
  }
  private _custom_ds_get_pallet_induction_info_by_licensePlateId: app_custom_ds_get_pallet_induction_info_by_licensePlateIdService;
  public get custom_ds_get_pallet_induction_info_by_licensePlateId(): app_custom_ds_get_pallet_induction_info_by_licensePlateIdService {
    if(!this._custom_ds_get_pallet_induction_info_by_licensePlateId) {
      this._custom_ds_get_pallet_induction_info_by_licensePlateId = this.injector.get(app_custom_ds_get_pallet_induction_info_by_licensePlateIdService);
    }
    return this._custom_ds_get_pallet_induction_info_by_licensePlateId;
  }
  private _custom_ds_get_pick_task_by_taskid: app_custom_ds_get_pick_task_by_taskidService;
  public get custom_ds_get_pick_task_by_taskid(): app_custom_ds_get_pick_task_by_taskidService {
    if(!this._custom_ds_get_pick_task_by_taskid) {
      this._custom_ds_get_pick_task_by_taskid = this.injector.get(app_custom_ds_get_pick_task_by_taskidService);
    }
    return this._custom_ds_get_pick_task_by_taskid;
  }
  private _custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId: app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService;
  public get custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId(): app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService {
    if(!this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId) {
      this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId = this.injector.get(app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderIdService);
    }
    return this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId;
  }
  private _custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2: app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service;
  public get custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2(): app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service {
    if(!this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2) {
      this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2 = this.injector.get(app_custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2Service);
    }
    return this._custom_ds_get_shipment_pick_tasks_by_shipmentId_orderId_v2;
  }
  private _ds_get_pick_tasks_by_licensePlateId: app_ds_get_pick_tasks_by_licensePlateIdService;
  public get ds_get_pick_tasks_by_licensePlateId(): app_ds_get_pick_tasks_by_licensePlateIdService {
    if(!this._ds_get_pick_tasks_by_licensePlateId) {
      this._ds_get_pick_tasks_by_licensePlateId = this.injector.get(app_ds_get_pick_tasks_by_licensePlateIdService);
    }
    return this._ds_get_pick_tasks_by_licensePlateId;
  }
}

